// This file is generated by a script. Do not edit this file directly.
import React from 'react';
import { Base } from "../Typography/Base";
import { Icon } from "../Icon";
import { TagImage } from "./TagImage";
var ColorVariantToBgColors = {
  "default": 'cop-bg-gray-200',
  info: 'cop-bg-[#e8f1ff]',
  success: 'cop-bg-[#e3ffef]',
  warning: 'cop-bg-[#fff8dd]',
  danger: 'cop-bg-danger'
};
var ColorVariantToBorderColors = {
  "default": 'cop-border-gray-300',
  info: 'cop-border-blue-300',
  success: 'cop-border-green-300',
  warning: 'cop-border-yellow-300',
  danger: 'cop-border-red-300'
};
var ColorVariantToTextColors = {
  "default": 'cop-primary',
  info: 'cop-text-[#0000ff]',
  success: 'cop-text-[#09aa6c]',
  warning: 'cop-text-[#ff7800]',
  danger: 'cop-text-danger'
};
var RemoveTag = function RemoveTag(_ref) {
  var onRemove = _ref.onRemove,
    onFocus = _ref.onFocus;
  return /*#__PURE__*/React.createElement("button", {
    className: "cop-rounded-full cop-border-none cop-bg-transparent cop-p-[2px] cop-text-current cop-shadow-none hover:cop-cursor-pointer hover:cop-bg-white",
    onClick: onRemove,
    onFocus: onFocus
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "Close",
    className: "cop-h-2 cop-w-2 cop-text-xs"
  }));
};
export var Tag = function Tag(_ref2) {
  var text = _ref2.text,
    color = _ref2.color,
    onRemove = _ref2.onRemove,
    onFocus = _ref2.onFocus,
    prefix = _ref2.prefix,
    className = _ref2.className;
  var bgColorClass = ColorVariantToBgColors[color !== null && color !== void 0 ? color : 'default'];
  var borderColorClass = ColorVariantToBorderColors[color !== null && color !== void 0 ? color : 'default'];
  var textColorClass = ColorVariantToTextColors[color !== null && color !== void 0 ? color : 'default'];
  return /*#__PURE__*/React.createElement("div", {
    className: ['cop-flex cop-h-[25px] cop-w-fit cop-items-center cop-justify-between cop-gap-[2px] cop-rounded-[35px] cop-border cop-border-solid cop-px-[10px]', bgColorClass, borderColorClass, textColorClass, className !== null && className !== void 0 ? className : ''].join(' ')
  }, prefix && /*#__PURE__*/React.createElement(React.Fragment, null, prefix === 'Plus' || prefix === 'ChevronDown' ? /*#__PURE__*/React.createElement(Icon, {
    icon: prefix,
    className: "cop-h-2 cop-w-2"
  }) : /*#__PURE__*/React.createElement(TagImage, {
    src: prefix,
    className: "cop-h-4 cop-w-4"
  })), /*#__PURE__*/React.createElement(Base, {
    size: "sm",
    variant: "body",
    tag: "p",
    leading: "075",
    weight: "medium"
  }, text), onRemove && /*#__PURE__*/React.createElement(RemoveTag, {
    onRemove: onRemove,
    onFocus: onFocus
  }));
};
